export const SPOT_IMAGES = {
  ohori: require("./assets/spots/ohori.jpg"),
  aburayama: require("./assets/spots/aburayama.jpg"),
  nokonoshima: require("./assets/spots/nokonoshima.jpg"),
  uminonakamichi: require("./assets/spots/uminonakamichi.jpg"),
  shikanoshima: require("./assets/spots/shikanoshima.jpg"),
  itoshima: require("./assets/spots/itoshima.jpg"),
  shiraito: require("./assets/spots/shiraito.jpg"),
  lalaport: require("./assets/spots/lalaport.jpg"),
  markis: require("./assets/spots/markis.jpg"),
  "science-museum": require("./assets/spots/science-museum.jpg"),
  "marine-world": require("./assets/spots/marine-world.jpg"),
  "fantasy-kids": require("./assets/spots/fantasy-kids.jpg"),
  guruguruya: require("./assets/spots/guruguruya.jpg"),
  "aeon-fukuoka": require("./assets/spots/aeon-fukuoka.jpg"),
  "aeon-chikushino": require("./assets/spots/aeon-chikushino.jpg"),
  "kidzania-like": require("./assets/spots/kidzania-like.jpg"),
  "daimyo-garden": require("./assets/spots/daimyo-garden.jpg"),
  "one-fukuoka": require("./assets/spots/one-fukuoka.jpg"),
  "tenjin-underground": require("./assets/spots/tenjin-underground.jpg"),
  "tenjin-area": require("./assets/spots/tenjin-area.jpg"),
  "tenjin-rooftop": require("./assets/spots/tenjin-rooftop.jpg"),
  "hakata-city": require("./assets/spots/hakata-city.jpg"),
  canal: require("./assets/spots/canal.jpg"),
  "nakasu-yatai": require("./assets/spots/nakasu-yatai.jpg"),
  dazaifu: require("./assets/spots/dazaifu.jpg"),
  "dazaifu-sando": require("./assets/spots/dazaifu-sando.jpg"),
  zoo: require("./assets/spots/zoo.jpg"),
  "boss-ezo": require("./assets/spots/boss-ezo.jpg"),
  "outlet-kitakyushu": require("./assets/spots/outlet-kitakyushu.jpg"),
  biopark: require("./assets/spots/biopark.jpg"),
  huis: require("./assets/spots/huis.jpg"),
  "yakuin-cafe": require("./assets/spots/yakuin-cafe.jpg"),
  "yakuin-park": require("./assets/spots/yakuin-park.jpg"),
  ropponmatsu421: require("./assets/spots/ropponmatsu421.jpg"),
  "acros-fukuoka": require("./assets/spots/acros-fukuoka.jpg"),
  "fukuoka-tower": require("./assets/spots/fukuoka-tower.jpg"),
  "momochi-beach": require("./assets/spots/momochi-beach.jpg"),
  "momochi-dinner": require("./assets/spots/momochi-dinner.jpg"),
  "hakata-riverwalk": require("./assets/spots/hakata-riverwalk.jpg"),
  // 以下は Wikimedia Commons のフリーライセンス写真(出典: Apple提出/画像クレジット.md)
  "yanagibashi-market": require("./assets/spots/yanagibashi-market.jpg"),
  "nagahama-market": require("./assets/spots/nagahama-market.jpg"),
  "karato-market": require("./assets/spots/karato-market.jpg"),
  "mojiko-retro": require("./assets/spots/mojiko-retro.jpg"),
  "kokura-castle-town": require("./assets/spots/kokura-castle-town.jpg"),
  "kumamoto-castle-town": require("./assets/spots/kumamoto-castle-town.jpg"),
  "maizuru-park": require("./assets/spots/maizuru-park.jpg"),
  tsunoshima: require("./assets/spots/tsunoshima.jpg"),
  "aso-drive": require("./assets/spots/aso-drive.jpg"),
  yufuin: require("./assets/spots/yufuin.jpg"),
  "beppu-onsen": require("./assets/spots/beppu-onsen.jpg"),
  "kurokawa-onsen": require("./assets/spots/kurokawa-onsen.jpg"),
  "ureshino-onsen": require("./assets/spots/ureshino-onsen.jpg"),
  "takeo-onsen": require("./assets/spots/takeo-onsen.jpg"),
  "fukuoka-onsen": require("./assets/spots/fukuoka-onsen.jpg"),
  // 追加スポット(Wikimedia Commons / 出典は Apple提出/画像クレジット.md)
  "nishi-park": require("./assets/spots/nishi-park.jpg"),
  "shinoguri-forest": require("./assets/spots/shinoguri-forest.jpg"),
  "island-city-park": require("./assets/spots/island-city-park.jpg"),
  miyajidake: require("./assets/spots/miyajidake.jpg"),
  sarakurayama: require("./assets/spots/sarakurayama.jpg"),
  "kawachi-fujien": require("./assets/spots/kawachi-fujien.jpg"),
  "nakanoshima-park": require("./assets/spots/nakanoshima-park.jpg"),
  akizuki: require("./assets/spots/akizuki.jpg"),
  hyuganami: require("./assets/spots/hyuganami.jpg"),
  "fukuoka-parco": require("./assets/spots/fukuoka-parco.jpg"),
  "kego-keyaki": require("./assets/spots/kego-keyaki.jpg"),
  haruyoshi: require("./assets/spots/haruyoshi.jpg"),
  "itoshima-cafe": require("./assets/spots/itoshima-cafe.jpg"),
  "hirao-bakery": require("./assets/spots/hirao-bakery.jpg"),
  // 映えスポット
  "kamado-jinja": require("./assets/spots/kamado-jinja.jpg"),
  "nanzoin": require("./assets/spots/nanzoin.jpg"),
  "munakata-taisha": require("./assets/spots/munakata-taisha.jpg"),
  "hiraodai": require("./assets/spots/hiraodai.jpg"),
  "raizan-sennyoji": require("./assets/spots/raizan-sennyoji.jpg"),
  "sanren-suisha": require("./assets/spots/sanren-suisha.jpg"),
  "yame-chaen": require("./assets/spots/yame-chaen.jpg"),
};
